const SkillsData = [
  { skillType: "web", id: "01", skill: "React", expertLevel: 85 },
  { skillType: "web", id: "02", skill: "Node.JS", expertLevel: 70 },
  { skillType: "web", id: "03", skill: "Express.JS", expertLevel: 70 },
  { skillType: "web", id: "04", skill: "MongoDB", expertLevel: 75 },
  { skillType: "web", id: "05", skill: "Bootstrap", expertLevel: 95 },
  { skillType: "web", id: "06", skill: "Meterial-UI", expertLevel: 75 },
  { skillType: "web", id: "07", skill: "HTML5", expertLevel: 95 },
  { skillType: "web", id: "08", skill: "CSS3", expertLevel: 95 },
  { skillType: "web", id: "09", skill: "MySQL", expertLevel: 70 },
  { skillType: "web", id: "10", skill: "BigData", expertLevel: 40 },

  { skillType: "programming", id: "11", skill: "JavaScript", expertLevel: 90 },
  { skillType: "programming", id: "12", skill: "Python", expertLevel: 50 },
  { skillType: "programming", id: "13", skill: "C#", expertLevel: 50 },

  { skillType: "tools", id: "14", skill: "Git", expertLevel: 80 },
  { skillType: "tools", id: "15", skill: "VSCode", expertLevel: 90 },
  { skillType: "tools", id: "16", skill: "Firebase", expertLevel: 90 },
  { skillType: "tools", id: "17", skill: "Heroku", expertLevel: 80 },
  { skillType: "tools", id: "18", skill: "Chrome Dev Tool", expertLevel: 80 },
  { skillType: "tools", id: "19", skill: "Npm", expertLevel: 80 },
  { skillType: "tools", id: "20", skill: "Netlify", expertLevel: 80 },
  { skillType: "tools", id: "21", skill: "AdobeXD", expertLevel: 80 },
  { skillType: "tools", id: "22", skill: "Figma", expertLevel: 80 },
];

export default SkillsData;
